export default "__VITE_ASSET__CW5G5TGo__";